import {useNavigate} from "react-router-dom";
import ClientComponent from "./ClientComponent";
import {getHistoryForGameId} from "../clients/HistoryClient";
import socket from "../utils/clientSocket";
import AcceptDenyModal from "./AcceptDenyModal";
import React, {useEffect, useState} from "react";
import {acceptDenyRematch, offerRematch} from "../clients/GameClient";
import {useUser} from "../UserContext";

const GameOverModal = ({winner, color, gameId}) => {
    const navigate = useNavigate()
    const user = useUser();

    const [rematchOfferId, setRematchOfferId] = useState(null)
    const [errorMsg, setErrorMsg] = useState(null)
    const [rematchOfferedStatus, setRematchOfferedStatus] = useState(null)

    useEffect(() => {
        socket.on("rematchOffered", (offerId) => {
            setRematchOfferId(offerId);
        })

        socket.on("rematchOfferDeclined", () => {
            setRematchOfferedStatus("Offer declined")
        })

        socket.on("rematchOfferCancelled", () => {
            setRematchOfferId(null)
        })

        return () => {
            socket.off("rematchOffered");
            socket.off("rematchOfferDeclined");
            //we use the old game id when creating a rematch offer - so cancel it using the same
            socket.emit("cancelRematchOffer", {offerId: gameId})
        }
    }, []);

    const goToAnalysis = (row) => {
        const state = {}
        state.initialFen = row.initialFen;
        state.moves = row.moves.trim().split(" ")
        state.playerColor = color === "w" ? "white" : "black";
        state.gameId = gameId;
        state.opponent = row.user1.username === user.username ? row.user2 : row.user1;

        navigate("/analysis", {state: state})
    }

    const handleRematchOffer = (isAccepted) => {
        acceptDenyRematch(rematchOfferId, isAccepted)
            .then(() => setRematchOfferId(() => null))
            .catch((e) => setErrorMsg(e.message))
    }

    const handleError = (error) => {
        setErrorMsg(error.response?.data?.message || error.message)
    }

    const handleAnalysisError = (error) => {
        //We need to override the unauthorized error with a better one
        if(error.response?.data?.message?.includes("Unauthorized")) {
            setErrorMsg("You must be logged in to view analysis")
        } else {
            handleError(error)
        }
    }

    const getHistoryAndGoToAnalysis = () => {
        getHistoryForGameId(gameId)
            .then(goToAnalysis)
            .catch(handleAnalysisError)
    }

    const extendRematchOffer = () => {
        console.log("offered rematch")
        offerRematch(gameId)
            .then(() => setRematchOfferedStatus("Rematch offered"))
            .catch(handleError)
    }

    return (<div className="modal-overlay">
        <div className="modal-content" style={{
            display: "flex",
            flexDirection: "column",
            overflow: 'hidden',
            justifyContent: "space-between",
        }}>
            <div>
                <div style={{
                    marginTop: "-1.3rem",
                    marginLeft: "-1.3rem",
                    width: "100%",
                    padding: "1.3rem",
                    backgroundColor: 'var(--primary-blue)',
                }}></div>
                <h3 style={{marginTop: '40px', color: "#888"}}>Gameover! Winner is: {winner}</h3>
            </div>
            <div style={{alignSelf: "flex-start", marginBottom: "0.5rem"}}>
                <button className="secondary-button" onClick={extendRematchOffer}>Rematch</button>
            </div>
            <div style={{display: "flex", justifyContent: "space-between"}}>
            <button className="minimalist-button" style={{border: "1px solid #ccc"}} onClick={() => navigate("/")}>Back to Menu</button>
                <button onClick={getHistoryAndGoToAnalysis}>View Analysis</button>
            </div>
            {rematchOfferedStatus && <div style={{width: "fit-content", padding: "1rem", marginTop: "0.5rem",
                backgroundColor: "#f5f5f5", alignSelf: "center", borderRadius: "0.5rem", boxShadow: "0 0.25rem 0.625rem rgba(0, 0, 0, 0.15)"}}>
                {rematchOfferedStatus}
            </div>}
            {rematchOfferId && <AcceptDenyModal statement={"A rematch has been offered. Accept?"}
                                                denyCallback={() => handleRematchOffer(false)}
                                                acceptCallback={() => handleRematchOffer(true)}
                                                style={{padding: "0", paddingLeft: "1rem", fontSize: "0.9rem"}}/>}
            {errorMsg && <div className="info-message error"
                 style={{width: "fit-content", padding: "1rem", marginTop: "0.5rem"}}>
                {errorMsg}
            </div>}

        </div>
    </div>)
}

export default GameOverModal;